// Типы для Star Control
export interface StarControlUser {
    user_id: number;
    photo: string;
    ref_link: string;
    full_name: string;
    rank: number;
    created_at: string;
    inviter_id: number | null;
    is_blocked: boolean;
    star_register_date: string;
    star_pay_date: string;
    star_team_total: number;
    balances: {
        main_wallet: number;
        main_future_star: number;
        usdt_wallet: number;
        usdt_future_star: number;
        total: number;
    };
    days_until_expiry: number;
}

export interface StarControlParams {
    page?: number;
    per_page?: number;
    sponsor_id?: number;
    days_ahead?: number;
    show_only_expiring?: boolean;
    show_only_low_balance?: boolean;
}

export interface StarControlResponse {
    data: StarControlUser[];
    meta: {
        current_page: number;
        last_page: number;
        per_page: number;
        total: number;
    };
}

export interface StarControlApiResponse {
    success: boolean;
    data: StarControlUser[];
    meta: {
        current_page: number;
        last_page: number;
        per_page: number;
        total: number;
    };
}

export const starControlEndpoints = {
    getStarControlUsers: {
        query: (params: StarControlParams) => ({
            url: "/admin/star-control",
            params,
        }),
    },
};

export const starControlTags = ["starControl"];
